import React from 'react';
import ReviewCard from './ReviewCard';

const ReviewList = ({ reviews, storeName, onReplySave, isReplySaving }) => {
  if (!reviews || reviews.length === 0) {
    return <p className="customer-reviews__empty">No reviews yet</p>;
  }
  return (
    <div className="customer-reviews__list">
      {reviews.map((review) => (
        <ReviewCard
          key={review.reviewUuid}
          review={review}
          storeName={storeName}
          onReplySave={onReplySave}
          isReplySaving={isReplySaving?.(review.reviewUuid)}
        />
      ))}
    </div>
  );
};

export default ReviewList;
